import { ECommunityCode } from "features/common/types";

export interface IRedirectConfig {
  login: string;
}

export type TEnvironment = "dev" | "uat" | "alt" | "prod";

const DEFAULT_COMMUNITY = ECommunityCode.UK;
const DEFAULT_ENV: TEnvironment = "dev";

const ENV_BY_HOST: Record<string, TEnvironment> = {
  "localhost": "dev",
  "portal-dev.onceforall.com": "dev",
  "portal-uat.onceforall.com": "uat",
  "portal-alt.onceforall.com": "alt",
  "portal.onceforall.com": "prod"
};

const REDIRECTS_BY_ENV: Record<TEnvironment, Record<ECommunityCode, IRedirectConfig>> = {
  dev: {
    [ECommunityCode.UK]: {
      login: "https://portal-dev.onceforall.com"
    },
    [ECommunityCode.FR]: {
      login: "https://app.dev.onceforall.com"
    }
  },
  uat: {
    [ECommunityCode.UK]: {
      login: "https://portal-uat.onceforall.com"
    },
    [ECommunityCode.FR]: {
      login: "https://app.uat.onceforall.com"
    }
  },
  alt: {
    [ECommunityCode.UK]: {
      login: "https://portal-alt.onceforall.com"
    },
    [ECommunityCode.FR]: {
      login: "https://app.alt.onceforall.com"
    }
  },
  prod: {
    [ECommunityCode.UK]: {
      login: "https://portal.onceforall.com"
    },
    [ECommunityCode.FR]: {
      login: "https://app.onceforall.com"
    }
  }
};

export const getRedirectConfig = (
  communityCode: ECommunityCode = DEFAULT_COMMUNITY
): IRedirectConfig => {
  const { hostname } = window.location;
  const env = ENV_BY_HOST[hostname] ?? DEFAULT_ENV;
  const envRedirects = REDIRECTS_BY_ENV[env]

  return envRedirects[communityCode] ?? envRedirects[DEFAULT_COMMUNITY];
};